import React from 'react';

import { Box, Typography } from '@mui/material';

interface Props {
  label: string;
  value: unknown;
}

function HeroPlannerDebugJsonSection({ label, value }: Props) {
  return (
    <Box>
      <Typography variant="overline" color="text.secondary">
        {label}
      </Typography>
      <Box
        component="pre"
        sx={{
          m: 0,
          p: 2,
          borderRadius: 1,
          bgcolor: 'action.hover',
          typography: 'caption',
          fontFamily: 'monospace',
          overflow: 'auto',
          maxHeight: '50vh',
        }}
      >
        {value === undefined ? 'No response body' : JSON.stringify(value, null, 2)}
      </Box>
    </Box>
  );
}

export default HeroPlannerDebugJsonSection;
